/**
 * Telemetria leve do PWA — console + um console.table no boot.
 * Filosofia: "medir antes de supor". Logamos display-mode, online, storage
 * disponivel e cada evento de auth/push pra debugar iOS PWA sem precisar
 * abrir DevTools remoto.
 */

import * as sessao from '../platform/storage';

const PREFIX = '[PWA]';

export function getDisplayMode() {
  if (typeof window === 'undefined') return 'ssr';
  if (window.matchMedia?.('(display-mode: standalone)').matches) return 'standalone';
  if (window.navigator.standalone === true) return 'ios-standalone'; // iOS Safari
  if (window.matchMedia?.('(display-mode: minimal-ui)').matches) return 'minimal-ui';
  return 'browser';
}

export function logPwaEvent(name, data = {}) {
  try {
    // eslint-disable-next-line no-console
    console.info(PREFIX, name, { t: new Date().toISOString(), ...data });
  } catch (_) { /* noop */ }
}

let bootLogged = false;
export function logBoot() {
  if (bootLogged) return;
  bootLogged = true;

  const hasStorage = (() => {
    try {
      localStorage.setItem('__pwa_probe', '1');
      localStorage.removeItem('__pwa_probe');
      return true;
    } catch { return false; }
  })();

  const hasSW = 'serviceWorker' in navigator;
  const hasPush = 'PushManager' in window;
  const hasNotif = 'Notification' in window;

  logPwaEvent('boot', {
    displayMode: getDisplayMode(),
    online: navigator.onLine,
    ua: navigator.userAgent,
    hasStorage,
    hasSW,
    hasPush,
    hasNotif,
    hasToken: !!sessao.getItem('token'),
    hasRefreshToken: !!sessao.getItem('refresh_token'),
  });
}
